import React from "react";
import { motion } from "framer-motion";
import { FaGithub, FaLinkedin, FaEnvelope } from "react-icons/fa";

const ProfileCard = ({ onProfileClick }) => {
  return (
    <motion.div
      className="max-w-sm mx-auto bg-[#1e1b4b] text-white rounded-2xl shadow-xl p-6 mt-12 cursor-pointer hover:shadow-indigo-700 transition"
      whileHover={{ scale: 1.05 }}
      onClick={onProfileClick}
    >
      <img
        src="https://media.licdn.com/dms/image/v2/D5603AQF5NXA_pyoc3g/profile-displayphoto-shrink_200_200/B56ZdUmVDXGQAc-/0/1749471024448?e=1766016000&v=beta&t=gv8JfR5jokohymizgD0idlo9S3ZH3Cu0w-Z5PmvAUVI"
        alt="Daniel Profile"
        className="w-32 h-32 mx-auto rounded-full border-4 border-indigo-500"
      />
      <h2 className="text-2xl font-bold text-center mt-4 text-indigo-400">
        Daniel
      </h2>
      <p className="text-center text-gray-300 text-sm">
        Software Engineer | Problem Solver | Code Enthusiast
      </p>

      <div className="flex justify-center gap-6 mt-4 text-xl">
        <a
          href="https://github.com/BlackSkull457"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-indigo-400 transition"
        >
          <FaGithub />
        </a>
        <a
          href="https://linkedin.com/in/daniel-liem-ab6a032bb"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-indigo-400 transition"
        >
          <FaLinkedin />
        </a>
        <a
          href="mailto:danielgiovaniliem457@gmail.com"
          className="hover:text-indigo-400 transition"
        >
          <FaEnvelope />
        </a>
      </div>

      <p className="text-center text-xs text-gray-400 mt-4">
        Click to view full profile
      </p>
    </motion.div>
  );
};

export default ProfileCard;
